/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
function a(a){return!!(a.visualVariableSizeMinMaxValue||a.visualVariableSizeScaleStops||a.visualVariableSizeStops||a.visualVariableSizeUnitValue||a.visualVariableSizeOutlineScaleStops)}function i(a){return!!a.visualVariableRotation}export{i as hasRotationVVUniform,a as hasSizeVVUniform};
